<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>详情</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
          "
          :span="24"
        >
          盘点单据
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="100"
            :data="resData.base"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="inventory_no"
              label="盘点单号"
            ></el-table-column>
            <el-table-column align="center" prop="range" label="盘点区域">
              <template slot-scope="scope">
                <span
                  >{{ scope.row.inventory_area_type }}-{{
                    scope.row.areas
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="ss_count"
              label="应盘仓位"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="should_count"
              label="应盘商品"
            ></el-table-column>
          </el-table>
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="100"
            :data="resData.base"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="create_time"
              label="创建时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="inventory_inventory_type"
              label="初盘方式"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="inventory_second_inventory_type"
              label="二盘方式"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="inventory_last_inventory_type"
              label="终盘方式"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-input v-model="form.sku" placeholder="sku编号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="form.space" placeholder="仓位"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.inventory_times"
                    placeholder="盘点次数"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in searchOptions.inventory_times"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_exception"
                    placeholder="是否异常"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in searchOptions.is_exception"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_chayi"
                    placeholder="最近两次盘点是否异常"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in searchOptions.is_chayi"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.inventory_detail_status"
                    placeholder="仓位盘点状态"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in searchOptions.inventory_detail_status"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
          :span="24"
        >
          <span>数据列表</span>
          <el-button
            type="primary"
            style="width: 120px; margin-left: auto"
            size="mini"
            @click="
              createTitle = '二盘';
              createVisible = true;
            "
            >创建二盘</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="
              createTitle = '终盘';
              createVisible = true;
            "
          >
            创建终盘</el-button
          >
          <el-button type="danger" size="mini" @click="beforeFinishInventory">
            结束盘点</el-button
          >
          <el-button type="primary" size="mini" @click="exportInventoryResult">
            下载盘点明细结果</el-button
          >
          <el-button type="success" size="mini" @click="exportExcel">
            导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.info"
            tooltip-effect="dark"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="space"
              label="仓位"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="sku"
              label="SKU编号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="co_val"
              label="颜色"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="si_val"
              label="尺码"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="stock_num"
              label="应盘数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="first_admin_name"
              label="初盘人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="first_num"
              label="初盘数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="first_exception_num"
              label="初盘差异"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="second_stock_num"
              label="二盘库存数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="second_admin_name"
              label="二盘人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="second_num"
              label="二盘数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="second_exception_num"
              label="二盘差异"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="last_stock_num"
              label="终盘库存数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="last_admin_name"
              label="终盘人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="last_num"
              label="终盘数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="last_exception_num"
              label="终盘差异"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="now_inventory_num"
              label="实盘数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="now_exception_num"
              label="当前差异"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="diff_price"
              label="差异成本（商品库拿货价）"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="inventory_detail_inventory_detail_status"
              label="仓位盘点状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="inventory_detail_is_chayi"
              label="最近两次盘点是否差异"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="inventory_inventory_times"
              label="盘点次数"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="inventory_detail_is_exception"
              label="是否异常"
            ></el-table-column>
          </el-table>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="100"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
          "
          :span="24"
        >
          操作记录
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="300"
            :data="resData.log"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column prop="action_admin" label="操作人">
            </el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="操作时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="action_desc"
              label="操作内容"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      :title="createTitle"
      :visible="createVisible"
      width="800px"
      :show-close="false"
    >
      <el-form>
        <el-form-item label="盘点类型">
          <el-select
            v-model="form.inventory_type"
            placeholder="盘点类型"
            filterable
            style="width: 250px"
          >
            <el-option
              v-for="item in createTypes"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createVisible = false">取 消</el-button>
        <el-button type="primary" @click="createNextInventory">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="结束盘点"
      :visible="finishVisible"
      width="800px"
      :show-close="false"
    >
      <h2>
        盘点结果:丢失{{ finishData.exception_num }}件,多出{{
          finishData.more_num
        }}件,是否结束盘点并修正数据!
      </h2>

      <div style="margin-bottom: 0">
        <el-table
          v-if="resData"
          ref="multipleTable"
          v-loading="tableLoading"
          height="300"
          :data="finishData.list"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column prop="dbid" label="打标id"> </el-table-column>
          <el-table-column
            align="center"
            prop="result"
            label="差异类型"
          ></el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="finishVisible = false">取 消</el-button>
        <el-button type="primary" @click="finishInventory">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: {},
      form: {
        inventory_id: this.$route.params.inventory_id,
      },
      msg: "",
      loading: false,
      tableLoading: false,
      url: "/erp/Inventory/InventoryDetail",
      curPage: 1,
      filterFold: false,
      dialogFormVisible: false,
      createVisible: false,
      finishVisible: false,
      createTitle: "",
      createTypes: [
        {
          key: "1",
          label: "全盘",
        },
        {
          key: "3",
          label: "差异盘",
        },
      ],
      searchOptions: {},
      finishData: {},
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    exportExcel() {
      this.form.is_excel = 1;
      this.fetchData();
    },
    beforeFinishInventory() {
      this.$http
        .post("/erp/Inventory/beforeFinishInventory", this.filteredForm)
        .then((res) => {
          if (res.data.code === 200) {
            this.finishData = res.data.data;
            this.finishVisible = true;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    finishInventory() {
      this.$http
        .post("/erp/Inventory/finishInventory", this.filteredForm)
        .then((res) => {
          if (res.data.code === 200) {
            this.finishVisible = false;
            this.$message.success(res.data.msg);
            this.exportInventoryResult();
            this.fetchData();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    exportInventoryResult() {
      this.$http
        .post("/erp/Inventory/exportInventoryResult", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.form.is_excel = 0;
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    createNextInventory() {
      let create_url = "/erp/Inventory/";
      if (!this.createTitle) {
        this.$message.error("参数错误,请重试");
        return false;
      }
      if (this.createTitle == "终盘") create_url += "CreateLastInventory";
      if (this.createTitle == "二盘") create_url += "CreateSecondInventory";
      this.$http.post(create_url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
          this.createVisible = false;
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.ss_id == 0 && this.resData.base[0].status == 10) {
        return "warning-row";
      }
      if (row.no_ss_num > 0 && this.resData.base[0].status == 10) {
        return "warning-row";
      }
      return "";
    },
    search() {
      this.fetchData(true);
    },
    reset() {
      this.form = {
        inventory_id: this.$route.params.inventory_id,
      };
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else if (this.form.is_excel == 1) {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        } else {
          this.resData = res.data.data;
          this.searchOptions = res.data.data.condition;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/inventory/Detail.vue